import React from 'react';

import Comments from '@components/Comments';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { CommentableType } from '@utils/backend-api/comments';

interface GraphicsPageCommentsProps {
  id: number;
  commentsCount: number;
}

const GraphicsPageComments = ({ id, commentsCount }: GraphicsPageCommentsProps) => {
  const hydrated = useServerSideRendering();

  return hydrated ? (
    <div className="w-full">
      <Comments
        commentableId={id}
        commentableType={CommentableType.Graphic}
        commentsCount={commentsCount}
      />
    </div>
  ) : null;
};

export default GraphicsPageComments;
